<template>
  <transition
    enter-active-class="transition-all ease-linear duration-300"
    leave-active-class="transition-all ease-linear duration-300"
    enter-from-class="opacity-0"
    leave-to-class="opacity-0"
  >
    <div
      v-if="openMenu"
      class="fixed inset-0 w-full h-full z-150 backdrop-blur-sm bg-black/60 transition-all duration-300"
    ></div>
  </transition>

  <div
    class="fixed inset-0 w-full h-full z-150 transition-transform duration-500"
    :class="openMenu ? 'translate-x-0' : '-translate-x-[100vw]'"
  >
    <div class="bg-white relative h-full w-full sm:w-[346px] flex flex-col">
      <div class="flex items-center justify-between px-6 py-[18px]">
        <button
          @click="$emit('closeSidebar')"
          class="cursor-pointer rounded-full w-[42px] h-[42px] flex justify-center items-center border-none bg-none"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="60"
            height="60"
            viewBox="0 0 60 60"
            fill="none"
          >
            <rect
              x="0.5"
              y="0.5"
              width="59"
              height="59"
              rx="29.5"
              stroke="#DBDBDB"
            />
            <path
              d="M35.8336 37.3189L23.1057 24.591C22.8157 24.3011 22.8157 23.8202 23.1057 23.5303C23.3956 23.2404 23.8764 23.2404 24.1663 23.5303L36.8942 36.2583C37.1842 36.5482 37.1842 37.029 36.8942 37.3189C36.6043 37.6088 36.1235 37.6088 35.8336 37.3189Z"
              fill="black"
            />
            <path
              d="M36.8944 24.591L24.1664 37.3189C23.8765 37.6088 23.3957 37.6088 23.1058 37.3189C22.8159 37.029 22.8159 36.5482 23.1058 36.2582L35.8337 23.5303C36.1236 23.2404 36.6044 23.2404 36.8944 23.5303C37.1843 23.8202 37.1843 24.3011 36.8944 24.591Z"
              fill="black"
            />
          </svg>
        </button>
        <img
          src="@/assets/images/header/logo-horizontal.svg"
          alt="Logo"
          class="w-[102px] max-h-[42px]"
        />
      </div>
      <hr class="border-t-[#DBDBDB] mb-0" />

      <div
        class="grow pt-[24px] 3xl:pt-[50px] 4xl:pt-[77px] px-[31px] flex flex-col overflow-auto h-full hide-scrollbar justify-between"
      >
        <div class="w-full h-fit">
          <h3 class="text-[14px] font-[500]">Menu</h3>
          <ul class="mt-6 my-list-disc">
            <li
              v-for="link in routes"
              :key="link.label"
              class="h-[56px] mb-2 text-[18px] md:text-[20px] font-medium"
            >
              <router-link
                :to="link.route"
                :exact-active-class="getActiveClass(link.label)"
                class="text-[#B7B7B7] h-[56px] flex items-center px-[16px] rounded-[12px]"
                @click="$emit('closeSidebar')"
              >
                {{ link.label }}
              </router-link>
            </li>
          </ul>
        </div>

        <div
          class="flex flex-col gap-3 items-center mt-[24px] mb-[40px] py-[32px] border-y border-[#F6F6F6]"
        >
          <ul class="my-list-disc w-full">
            <li
              @click="$emit('closeSidebar')"
              class="h-[56px] mb-2 text-[18px] md:text-[20px] font-medium"
            >
              <router-link
                class="text-[#B7B7B7] h-[56px] flex items-center px-[16px] rounded-[12px]"
                :to="{ name: 'favouritesPage' }"
                :exact-active-class="getActiveClass('favouritesPage')"
              >
                Favourites
              </router-link>
            </li>
            <li
              @click="$emit('closeSidebar')"
              v-if="+showWorksheetRoute"
              class="h-[56px] mb-2 text-[18px] md:text-[20px] font-medium"
            >
              <router-link
                class="text-[#B7B7B7] h-[56px] flex items-center px-[16px] rounded-[12px]"
                :to="{ name: 'worksheet' }"
                :exact-active-class="getActiveClass('worksheet')"
              >
                Submit Worksheet
              </router-link>
            </li>
          </ul>
        </div>
        <div
          class="flex flex-col gap-3 mt-5"
          :class="[store.isAgent ? 'mb-[93px]' : 'mb-[42px]']"
        >
          <p
            class="text-qooBlack-7 text-[18px] md:text-[20px] font-medium flex gap-2 cursor-pointer items-center justify-start"
            @click="logout"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M16.8 2H14.2C11 2 9 4 9 7.2V11.25H15.25C15.66 11.25 16 11.59 16 12C16 12.41 15.66 12.75 15.25 12.75H9V16.8C9 20 11 22 14.2 22H16.79C19.99 22 21.99 20 21.99 16.8V7.2C22 4 20 2 16.8 2Z"
                fill="#E5E5E5"
              />
              <path
                d="M4.55994 11.2498L6.62994 9.17984C6.77994 9.02984 6.84994 8.83984 6.84994 8.64984C6.84994 8.45984 6.77994 8.25984 6.62994 8.11984C6.33994 7.82984 5.85994 7.82984 5.56994 8.11984L2.21994 11.4698C1.92994 11.7598 1.92994 12.2398 2.21994 12.5298L5.56994 15.8798C5.85994 16.1698 6.33994 16.1698 6.62994 15.8798C6.91994 15.5898 6.91994 15.1098 6.62994 14.8198L4.55994 12.7498H8.99994V11.2498H4.55994Z"
                fill="#E5E5E5"
              />
            </svg>
            <span class="">log out</span>
          </p>
        </div>
      </div>
      <a
        href="https://agent.qoobox.qoo.studio/#/login"
        v-if="store.isAgent"
        class="absolute bottom-0 left-0 z-20 w-full h-[72px] border-t border-qooWhite-3 bg-white"
        target="_blank"
      >
        <div class="flex h-full justify-center items-center gap-3">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              d="M12.9999 11.7483C12.8099 11.7483 12.6199 11.6783 12.4699 11.5283C12.1799 11.2383 12.1799 10.7583 12.4699 10.4683L20.6699 2.26828C20.9599 1.97828 21.4399 1.97828 21.7299 2.26828C22.0199 2.55828 22.0199 3.03828 21.7299 3.32828L13.5299 11.5283C13.3799 11.6783 13.1899 11.7483 12.9999 11.7483Z"
              fill="#3D3D3D"
            />
            <path
              d="M22 7.55C21.59 7.55 21.25 7.21 21.25 6.8V2.75H17.2C16.79 2.75 16.45 2.41 16.45 2C16.45 1.59 16.79 1.25 17.2 1.25H22C22.41 1.25 22.75 1.59 22.75 2V6.8C22.75 7.21 22.41 7.55 22 7.55Z"
              fill="#3D3D3D"
            />
            <path
              d="M15 22.75H9C3.57 22.75 1.25 20.43 1.25 15V9C1.25 3.57 3.57 1.25 9 1.25H11C11.41 1.25 11.75 1.59 11.75 2C11.75 2.41 11.41 2.75 11 2.75H9C4.39 2.75 2.75 4.39 2.75 9V15C2.75 19.61 4.39 21.25 9 21.25H15C19.61 21.25 21.25 19.61 21.25 15V13C21.25 12.59 21.59 12.25 22 12.25C22.41 12.25 22.75 12.59 22.75 13V15C22.75 20.43 20.43 22.75 15 22.75Z"
              fill="#3D3D3D"
            />
          </svg>
          <p
            class="text-qooBlack-5 text-[18px] 4xl:text-lg font-medium underline"
          >
            Open QOO Agent Panel
          </p>
        </div>
      </a>
    </div>
  </div>
</template>

<script setup>
import { useRoute } from "vue-router";
import { useCookies } from "vue3-cookies";
import CustomScrollbar from "@/components/base/CustomScrollbar.vue";
import { useStore } from "@/store/loading.js";

const store = useStore();
const { cookies } = useCookies();
defineEmits(["closeSidebar"]);
const showWorksheetRoute = process.env.VUE_APP_SHOW_WORKSHEET;

const props = defineProps({
  openMenu: {
    type: Boolean,
    default: false,
  },
});
const routes = [
  {
    label: "Building",
    route: { name: "floorplans", query: { full_3d: true } },
  },
  {
    label: "Floorplans",
    route: { name: "floorplans", query: { full_3d: false } },
  },
  {
    label: "Neighbourhood",
    route: { name: "neighbourhood" },
  },
  {
    label: "Gallery",
    route: { name: "gallery" },
  },
  {
    label: "Builder Story",
    route: { name: "builderstory-page" },
  },
  {
    label: "Broker Package",
    route: { name: "broker-package-page" },
  },
  // {
  //   label: "Feature and Finishes",
  //   route: { name: "feature-and-finishes" },
  // },
];

const route = useRoute();

// const activeBuilding = computed(() => {
//   return route.query.full_3d === "true";
// });

const logout = () => {
  cookies.remove("token");
  localStorage.removeItem("user");
  setTimeout(() => {
    location.reload();
  }, 2000);
};

function getActiveClass(label) {
  if (route.query.compare === "true") {
    return;
  }
  if (route.query.full_3d) {
    if (route.query.full_3d === "true" && label === "Building") {
      return "active-route";
    } else if (route.query.full_3d === "false" && label === "Floorplans") {
      return "active-route";
    }
  } else {
    return "active-route";
  }
}
</script>

<style lang="scss" scoped>
.active-route {
  color: #ffffff;
  position: relative;
  background-color: #2460e6;
}

.my-list-disc {
  li {
    a {
      transition: 0.3s ease-in all;
      &:hover {
        color: #454545;
        background-color: #2462e620;
        &::before {
          background-color: #d9d9d900;
        }
      }
    }
    a::before {
      content: " ";
      transition: 0.3s ease-in all;
      position: relative;
      width: 6px;
      display: block;
      height: 6px;
      left: -12px;
      background-color: #d9d9d9;
      border-radius: 50%;
    }

    a.active-route {
      &::before {
        content: none;
      }
      &:hover {
        color: #ffffff;
        background-color: #2460e6;
      }
    }
  }
}
</style>
